import { render, staticRenderFns } from "./PostNewJobWrapper.vue?vue&type=template&id=244b0538&scoped=true"
import script from "./PostNewJobWrapper.vue?vue&type=script&lang=ts"
export * from "./PostNewJobWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b0538",
  null
  
)

export default component.exports